import React, { useContext, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, CircularProgress, Box, Grid
} from "@mui/material";
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useDropzone } from 'react-dropzone';
import { AppContext } from "../context/AppProvider";
import { AuthContext } from "../context/AuthProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";


const DropArea = styled('div')(({ theme }) => ({
  border: '2px dashed #aaa',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(4),
  textAlign: 'center',
  cursor: 'pointer',
  backgroundColor: theme.palette.background.default,
  minHeight: 150,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export default function UpdateCostCin7Dialog({ open, onClose }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const context = useContext(AppContext);
  const authContext = useContext(AuthContext);

  const handleChangeFile = (files) => {
    setFile(files[0]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: acceptedFiles => handleChangeFile(acceptedFiles),
    maxFiles: 1,
    maxSize: 10000000,
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.ms-excel': ['.csv']
    }
  });

  const handleSubmit = async () => {
    if (!file) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await fetchWithInterceptor("/api/inventory-management/cin7-cost-upload", {
        method: "POST",
        body: formData,
        headers: {
          'x-access-token': authContext.getToken()
        },
      });
      setLoading(false);
      if (response.ok) {
        onClose(true);
      } else {
        const error = await response.json();
        context.showMessage(error?.message || "Invalid file", "error");
      }
    } catch (error) {
      context.showMessage("Invalid file", "error");
      setLoading(false);
    }
  };

  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth="sm"
      aria-labelledby="delete-dialog"
      open={open}
    >
      <DialogTitle id="delete-dialog">Upload Cin7 Cost File</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ width: '100%' }}>
          <Grid size={{ xs: 12 }}>
            <Box sx={{ minHeight: 200 }}>
              <DropArea {...getRootProps()}>
                <input {...getInputProps()} />
                <CloudUploadIcon sx={{ fontSize: 40, mb: 1 }} />
                <Typography  sx={{ textAlign: 'center', fontSize: '1.5rem' }}>
                  Drag and drop the CSV file here or click
                </Typography>
              </DropArea>
            </Box>
            <Typography variant="subtitle1" sx={{ mt: 2 }}>
              {`Uploaded file: ${file ? file.name : "-"}`}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="primary">Cancel</Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={!file || loading}>
          {loading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
